module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAFMN540AAAAAXNSR0IArs4c6QAAAS5JREFUSA1jYMAFZsyYcRaXHFni06dPjyZLI6YmotwGVBSDqXWwisydO1cKr9tmz54tg1fBUJckKlLRPQlMVP/RxUjiz5s3T5bilDns44akIKWlYmBIO/3//58Rlx1MuCRAGhkZGV8BMWkJBqRxzpw5OrgMxitOrEaszv79+/dMvKYTkgSm66OE1OCVp9iAVatWMeO1YVRyNARoFwKgvAtMgpyk2sBCqgaYepCFf//+7QaWMvFhYWHfYeLE0jjLNVwGwCxkYWGJT0lJuYJLHSFxoi2eNWuW/b9///ootRDmIKwlH0wSmQZaughY8vdR4ktk84j2MUgTqJXw8+fPFUDmtMzMzKXIBpHKJslimOEwBwAT1vSMjIwlMHG60cCEJgOqDvBVvnRzzKhFgy4EAAcvbyOj2XU/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/live/calendar_left_btn.png
// module id = wXJv
// module chunks = 1